import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {loadRegions} from 'store/slices/regions-slice/api/thunks';
import {REGIONS_SLICE} from 'store/slices/regions-slice/model/constants';
import {IRegionsState, IRegionDto} from 'store/slices/regions-slice/model/types';

const initialState: IRegionsState = {
    data: [],
};

export const regionsSlice = createSlice({
    initialState,
    name: REGIONS_SLICE,
    reducers: {
        setRegions(state, {payload: data}: PayloadAction<IRegionDto[]>) {
            state.data = data;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(loadRegions.fulfilled, (state, action) => {
                state.data = action.payload;
            });
    },
});

export const {reducer: regionsSliceReducer} = regionsSlice;
